<template>
  <router-view />
</template>

<style lang="scss">
p {
  margin: 0;
}

.el-select {
  min-width: 160px !important;
}

.form-box-line {
  display: flex;
  padding: 16px;
  flex-wrap: wrap;
}

.el-form-item__label {
  line-height: normal !important;
  align-items: center !important;

  &:before {
    content: "" !important;
    margin: 0;
  }
}

.form-box-1 {
  display: grid;
  padding: 16px;
  min-width: 300px;
  grid-template-columns: 1fr;
  gap: 16px;
  box-sizing: border-box;
  text-align: left;
}

.form-box-2 {
  width: 100%;
  display: grid;
  // 平均分布2列
  grid-template-columns: 1fr 1fr;
  padding: 16px;
  box-sizing: border-box;
  text-align: left;
  gap: 16px;
}

.form-box-3 {
  display: grid;
  grid-template-columns: 300px 300px 300px;
  padding: 16px;
  box-sizing: border-box;
  text-align: left;
  gap: 16px;
}
.clickForDetails {
  cursor: pointer;
  color: #409eff;
  font-weight: 600;
}
// dialog 弹框关闭按钮大小
.el-dialog__headerbtn {
  font-size: 35px !important; /* 调整按钮大小 */
}
</style>

<script>
</script>